<template>
	<div>{{ slider.slider_title }}</div>
</template>

<script>
	export default {
		props: ["slider"],
	};
</script>